// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "RETROSPECTIVA DO ANO",
    "note": "*Todas as estatísticas nesta retrospectiva foram obtidas em 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nVocê jogou o KKPoker pela primeira vez em 2025."
  },
  "report": {
    "loginTime": "Desde então,\no KKPoker acompanhou você por \n{loginDay}",
    "loginTips": "*Dias conectados no KKPoker em 2025.",
    "enjoyTime": "{loginTime}\né a hora mais agradável do dia para você! É o seu momento preferido para abrir o KKPoker!",
    "firstHandDate": "{first_hand_date}\nVocê recebeu sua primeira mão do ano jogando {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "Neste ano, você jogou um total\nde {hands}\nno KKPoker.\nSua paixão pelo poker superou a de \n{percentage} dos jogadores.",
    "v2": "Neste ano, você jogou um total\nde {hands}\nno KKPoker.\nObrigado por fazer parte de nossa jornada!",
    "v3": "Neste ano, você jogou um total\nde {hands}\nno KKPoker.\nO KKPoker tentará melhorar e proporcionar aos senhores uma experiência ainda mais agradável no próximo ano."
  },
  "hardTime": {
    "date": "{one_day_hands}\nEste foi o dia em que você mais se dedicou no KKPoker",
    "hands": "você jogou um total de\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "Além das suas mãos, você jogou\n{handsNum} {hands} no seu jogo favorito, {game}",
  "kkWin": {
    "v1": "Em 2025, você conseguiu um KK\n{all} {longTimes}\ne derrotou seus adversários com KK\n{win} {longTimesTwo}",
    "v2": "Este ano, você foi de all-in\n{all} {threeTimes}\nSeu índice de vitórias em all-in foi de:\n{percentage}\nO poker é um jogo para os destemidos!"
  },
  "achievement": {
    "spinup": "{spinup_date}\nfoi seu dia de sorte! Nesse dia",
    "spinup_2": "você atingiu o multiplicador {spinup_ratio} de SpinUp e ganhou\n{spinup_reward}",
    "mtt": "{mtt_date}\nfoi um dia especial.",
    "mtt_2": "Naquele dia,\nvocê ficou em {mtt_rank} lugar de {mtt_name}\ne ganhou\n{mtt_reward}",
    "rg": "{rg_date}\nUm dia marcante em sua jornada de pôquer!",
    "rg_2": "você ganhou seu maior pot do ano:\n{rg_reward}"
  },
  "lucky": {
    "title": "Cada mão conta\numa história diferente.",
    "luckyHand": "MÃO\nSORTUDA",
    "unLuckyHand": "MÃO\nAZARADA",
    "luckyRate": "Taxa de ganhos\n{lucky_rate}",
    "unLuckyRate": "Taxa de ganhos\n{unlucky_rate}",
    "luckyText": "{lucky_hand} fez o papel de herói.\nVocê ganhou {lucky_rate} das vezes em que o tinha consigo!",
    "unLuckyText": "Cuidado com o {unlucky_hand}...\nVocê só ganhou {unlucky_rate} das vezes com ele.",
    "note": "*Somente mãos iniciais distribuídas 10 vezes ou mais são elegíveis."
  },
  "futureStory": "O KKPoker mal pode esperar para continuar escrevendo com você a história da sua jornada de poker em 2026.",
  "version3": {
    "text": "Infelizmente, você não deixou nenhuma lembrança com o KKPoker em 2025.",
    "continue": "Venha escrever o próximo capítulo\nde sua jornada KKPoker em 2026!",
    "tips": " *Todas as estatísticas são de 2024-12-31."
  },
  "button": {
    "save": "Salvar im.",
    "copy": "Copiar e compartilhar"
  },
  "unit": {
    "days": "dias",
    "hands": "mãos",
    "longHands": "mãos",
    "longTimes": "vezes",
    "longTimesTwo": "vezes",
    "threeTimes": "vezes",
    "times": "vezes",
    "multiplier": "multiplicador ",
    "num": "",
    "num2": "",
    "bets": "apostas",
    "skUnits": "o de"
  },
  "toast": {
    "linkCopied": "Link copiado",
    "imageSaved": "Imagem salva"
  }
}
  